import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {CookieService} from 'ngx-cookie-service';
import {OidcSecurityService} from "angular-auth-oidc-client";
import {catchError} from "rxjs/operators";
import {NEVER, of, throwError} from "rxjs";
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  developingMode = false;
  api = 'https://app.elimedi.com';

  constructor(private http: HttpClient,
              private cookieService: CookieService,
              public oidcSecurityService: OidcSecurityService,
              private router: Router) {
    if (this.developingMode) {
      this.api = '';
    }
  }

  currentDirection = 'rtl';

  onSetLanguage(language, lan_id) {
    this.cookieService.set('dir', language)
    this.cookieService.set('lang', lan_id);
  }
  apiCall(method, route, body) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      lang: this.cookieService.get('lang'),
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    // console.log(this.oidcSecurityService.getToken())
    // this.oidcSecurityService.forceRefreshSession().subscribe((res: any) => {
    //   console.log('-----------------',res)
    //   if(res){
    //     this.oidcSecurityService.revokeAccessToken(res.accessToken).subscribe((res: any) => {
    //       console.log('++++++++++++++++++++',res)
    //       console.log(this.oidcSecurityService.getToken())
    //     })
    //   }
    //
    // })
    // console.log(this.oidcSecurityService.getRefreshToken())
    // this.oidcSecurityService.revokeRefreshToken(this.oidcSecurityService.getRefreshToken()).subscribe((res:any)=>{
    //   console.log('................refresh.......................',res)
    // })

    if (method == 'post') {
      return this.http.post(this.api + route, body, {headers})
      // .pipe(
      //   catchError(error => {
      //     this.router.navigate(['']);
      //     return of([]);
      //   })
      // );
    } else if (method == 'get') {
      return this.http.get(this.api + route, {headers})
      // .pipe(
      //   catchError(error => {
      //     if(error.status === 401){
      //       this.router.navigate(['']);
      //       return NEVER;
      //     }
      //     return of([]);
      //   })
      // );
    } else if (method == 'delete') {
      return this.http.delete(this.api + route, {headers});
    } else if (method == 'put') {
      return this.http.put(this.api + route, body, {headers});
    }
  }

  handleError(error: any) {
    // console.log('lalalalalalalala', error.status);
    if (error.status == 401) {
      // this.oidcSecurityService.forceRefreshSession().subscribe((res: any) => {
      //   console.log(res)
      //   if(res){
      //     this.oidcSecurityService.revokeAccessToken(res.accessToken).subscribe((res: any) => {
      //       console.log(res)
      //       console.log(this.oidcSecurityService.getToken())
      //     })
      //   }
      //
      // })
      // console.log(this.oidcSecurityService.getToken())
      // this.oidcSecurityService.revokeRefreshToken(this.oidcSecurityService.getRefreshToken()).subscribe((res:any)=>{
      //   console.log(res)
      //
      // })
    }

   // return throwError(error);
  }
  GetLanguages() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.get(this.api + '/api/admin/GetLanguages', {headers});
  }

  RegisterConfirm() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.get(this.api + '/api/Account/RegisterConfirm', {headers});
  }

// -------------------------------------------------------------------training---------------------------------------------------------------------

  // GetTrainingCategories() {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.get(this.api + '/api/TrainingAdmin/GetTrainingCategories', {headers});
  // }

  // EditTrainingCategory(id) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     'lang': this.cookieService.get('lang')
  //   });
  //   return this.http.get(this.api + '/api/TrainingAdmin/EditTrainingCategory/' + id, {headers});
  // }
  //
  // UpdateTrainingCategory(body) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     'lang': this.cookieService.get('lang')
  //   });
  //   console.log('headers', headers);
  //   return this.http.put(this.api + '/api/TrainingAdmin/UpdateTrainingCategory/', body, {headers});
  // }
  //
  // AddTrainingCategory(body) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     'lang': this.cookieService.get('lang')
  //   });
  //   return this.http.post(this.api + '/api/TrainingAdmin/AddTrainingCategory/', body, {headers});
  // }

  // GetAllTrainingPost(body) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/TrainingAdmin/GetAllTrainingPost/' + this.cookieService.get('lang'), body, {headers});
  // }
  //
  // EditTrainingPost(id) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/TrainingAdmin/EditTrainingPost/' + id, {headers});
  // }
  //
  // UpdateTrainingPost(body) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.put(this.api + '/api/TrainingAdmin/UpdateTrainingPost/', body, {headers});
  // }

  // AddTrainingPost(body) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/TrainingAdmin/AddTrainingPost/', body, {headers});
  // }
  //
  // DeleteTrainingPost(postid, languageId) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/TrainingAdmin/DeleteTrainingPost/' + postid + '/' + languageId, {headers});
  // }
  //
  // DeleteTrainingCategory(categoryId) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/TrainingAdmin/DeleteTrainingCategory/' + categoryId, {headers});
  // }

  // -------------------------------------------------------------Hobbies-------------------------------------------------------------------------
  // GetGames() {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/GameAdmin/GetGames/' + this.cookieService.get('lang'), {headers});
  // }
  //
  // AddGame(body) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/GameAdmin/AddGame/', body, {headers});
  // }

  // editgame(id) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/GameAdmin/editgame/' + id, {headers});
  // }
  //
  // updategame(body) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.put(this.api + '/api/GameAdmin/updategame/', body, {headers});
  // }
  //
  // DeleteGame(id) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/GameAdmin/DeleteGame/' + id, {headers});
  // }

//---------------------------------------------------------------Temperamentology--------------------------------------------------------------------------
//   GetNatures() {
//     const headers = new HttpHeaders({
//       'Content-Type': 'application/json;charset=UTF-8',
//       Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
//     });
//     return this.http.get(this.api + '/api/TemperamentSurveyAdmin/GetNatures/' + this.cookieService.get('lang'), {headers});
//   }
//
//   DeleteNature(id) {
//     const headers = new HttpHeaders({
//       'Content-Type': 'application/json;charset=UTF-8',
//       Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
//     });
//     return this.http.delete(this.api + '/api/TemperamentSurveyAdmin/DeleteNature/' + id, {headers});
//   }
//
//   EditNature(id) {
//     const headers = new HttpHeaders({
//       'Content-Type': 'application/json;charset=UTF-8',
//       Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
//     });
//     return this.http.get(this.api + '/api/TemperamentSurveyAdmin/EditNature/' + id + '/' + this.cookieService.get('lang'), {headers});
//   }
//   UpdateNature(body){
//     const headers = new HttpHeaders({
//       'Content-Type': 'application/json;charset=UTF-8',
//       Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
//     });
//     return this.http.post(this.api + '/api/TemperamentSurveyAdmin/UpdateNature/' ,body, {headers});
//   }
  // GetResults(){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/TemperamentSurveyAdmin/GetResults/'+ this.cookieService.get('lang'), {headers});
  // }
  // EditQuestion(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/TemperamentSurveyAdmin/EditQuestion/'+ id+ '/'+this.cookieService.get('lang') , {headers});
  // }

  // GetQuestions(){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/TemperamentSurveyAdmin/GetQuestions/'+ this.cookieService.get('lang'), {headers});
  // }
  // UpdateQuestion(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/TemperamentSurveyAdmin/UpdateQuestion/' ,body, {headers});
  // }
  AddQuestion(body){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.post(this.api + '/api/TemperamentSurveyAdmin/AddQuestion/' ,body, {headers});
  }
  // DeleteQuestion(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/TemperamentSurveyAdmin/DeleteQuestion/' + id, {headers});
  // }
  // AddNature(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/TemperamentSurveyAdmin/AddNature/' ,body, {headers});
  // }
  //----------------------------------------------------------MedicalFormulary----------------------------------------------------------------
  // GetFormules(){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/MedicalFormularyAdmin/GetFormules/', {headers});
  // }
//--------------------------------------------------------------MedicalDiagnosis-----------------------------------------------------------------
//   GetCategories(){
//     const headers = new HttpHeaders({
//       'Content-Type': 'application/json;charset=UTF-8',
//       Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
//     });
//     return this.http.get(this.api + '/api/MedicalDiagnosisAdmin/GetCategories/'+ this.cookieService.get('lang'), {headers});
//   }
//   EditCategory(id){
//     const headers = new HttpHeaders({
//       'Content-Type': 'application/json;charset=UTF-8',
//       Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
//     });
//     return this.http.get(this.api + '/api/MedicalDiagnosisAdmin/EditCategory/'+ id , {headers});
//   }
  // UpdateCategory(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/MedicalDiagnosisAdmin/UpdateCategory/' ,body, {headers});
  // }
  // AddCategory(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/MedicalDiagnosisAdmin/AddCategory/' ,body, {headers});
  // }
  // DeleteCategory(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/MedicalDiagnosisAdmin/DeleteCategory/'+id, {headers});
  // }
  // GetResult(){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/MedicalDiagnosisAdmin/GetResult/'+ this.cookieService.get('lang'), {headers});
  // }
  // DeleteResult(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/MedicalDiagnosisAdmin/DeleteResult/'+id, {headers});
  // }
  // AddResult(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/MedicalDiagnosisAdmin/AddResult/',body, {headers});
  // }
  // EditResult(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/MedicalDiagnosisAdmin/EditResult/'+id+ '/'+this.cookieService.get('lang') , {headers});
  // }
  // UpdateResult(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/MedicalDiagnosisAdmin/UpdateResult/',body , {headers});
  // }
  // GetMedications(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/MedicalDiagnosisAdmin/GetMedications/'+id+'/'+this.cookieService.get('lang') , {headers});
  // }
  // EditMedication(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/MedicalDiagnosisAdmin/EditMedication/'+id, {headers});
  // }
  // UpdateMedication(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/MedicalDiagnosisAdmin/UpdateMedication/',body , {headers});
  // }
  // DeleteMedication(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/MedicalDiagnosisAdmin/DeleteMedication/'+id, {headers});
  // }
  // AddMedication(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/MedicalDiagnosisAdmin/AddMedication/',body , {headers});
  // }
  // GetQuestion(categoryId, questionId){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/MedicalDiagnosisAdmin/GetQuestion/'+this.cookieService.get('lang')+ '/'+categoryId + '/'+ questionId , {headers});
  // }
  // AddQuestionMD(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/MedicalDiagnosisAdmin/AddQuestion' ,body, {headers});
  // }
  // EditQuestionMD(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/MedicalDiagnosisAdmin/EditQuestion/'+id+'/'+this.cookieService.get('lang'), {headers});
  // }
  // UpdateQuestionMD(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/MedicalDiagnosisAdmin/UpdateQuestion/',body, {headers});
  // }
  // DeleteQuestionMD(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/MedicalDiagnosisAdmin/DeleteQuestion/'+id, {headers});
  // }
  // DeleteAnswerMD(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/MedicalDiagnosisAdmin/DeleteAnswer/'+id, {headers});
  // }
  // //---------------------------------------------Service Map--------------------------------------------------------
  // getListPlaceType(){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/ServiceMapAdmin/getListPlaceType/', {headers});
  // }
  // addPlaceType(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/ServiceMapAdmin/addPlaceType/',body, {headers});
  // }
  // removePlaceType(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/ServiceMapAdmin/removePlaceType/'+id, {headers});
  // }
  // EditPlaceType(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/ServiceMapAdmin/EditPlaceType/'+id, {headers});
  // }
  // updatePlaceType(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/ServiceMapAdmin/updatePlaceType/',body, {headers});
  // }
  // GetAllLocations(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/ServiceMapAdmin/GetAllLocations/',body, {headers});
  // }
  // AddLocation(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/ServiceMapAdmin/AddLocation/',body, {headers});
  // }
  // GetCountries() {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.get(this.api + '/api/serviceMap/GetCountries/', {headers});
  // }
  //
  // GetProvinces(id) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.get(this.api + '/api/serviceMap/GetProvinces/' + id, {headers});
  // }

  // Getcities(id) {
  //   const headers = new HttpHeaders({
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken(),
  //     lang: this.cookieService.get('lang'),
  //     'Content-Type': 'application/json;charset=UTF-8'
  //   });
  //   return this.http.get(this.api + '/api/serviceMap/GetCities/' + id, {headers});
  // }
  // EditLocation(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/ServiceMapAdmin/EditLocation/'+id, {headers});
  // }
  // UpdateLocation(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.put(this.api + '/api/ServiceMapAdmin/UpdateLocation/',body, {headers});
  // }
  // ToggleLocationStatus(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.put(this.api + '/api/ServiceMapAdmin/ToggleLocationStatus/'+id,{}, {headers});
  // }
  // AddLocationPicture(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/ServiceMapAdmin/AddLocationPicture/',body, {headers});
  // }
  // DeleteLocationPicture(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/ServiceMapAdmin/DeleteLocationPicture/'+id, {headers});
  // }
  // DeleteLocation(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/ServiceMapAdmin/DeleteLocation/'+id, {headers});
  // }
  //--------------------------------------------------------------Diet---------------------------------------------------------------
  // ShowQuestionnaires(){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/AdminDiet/ShowQuestionnaires/', {headers});
  // }
  // EditQuestionnaires(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/AdminDiet/EditQuestionnaires/'+id, {headers});
  // }
  // UpdateQuestionnaires(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/AdminDiet/UpdateQuestionnaires/',body, {headers});
  // }
  // AddQuestionnaires(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/AdminDiet/AddQuestionnaires/',body, {headers});
  // }
  // GetAllDiet(){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/AdminDiet/GetAllDiet/', {headers});
  // }
  // AddDiet(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/AdminDiet/AddDiet/',body, {headers});
  // }
  // DeleteDiet(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/AdminDiet/DeleteDiet/'+id, {headers});
  // }
  // DeleteQuestionnaires(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/AdminDiet/DeleteQuestionnaires/'+id, {headers});
  // }
  // AddQuestionDiet(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/AdminDiet/AddQuestion/',body, {headers});
  // }
  // EditQuestionDiet(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/AdminDiet/EditQuestion/'+id, {headers});
  // }
  // DeleteQuestionDiet(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/AdminDiet/DeleteQuestion/'+id, {headers});
  // }
  // UpdateQuestionDiet(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/AdminDiet/UpdateQuestion/',body, {headers});
  // }
  // showUnit(){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/AdminDiet/showUnit/', {headers});
  // }
  // EditUnit(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/AdminDiet/EditUnit/'+id, {headers});
  // }
  // DeleteUnit(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/AdminDiet/DeleteUnit/'+id, {headers});
  // }
  // Addunit(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/AdminDiet/Addunit/',body, {headers});
  // }
  // UpdateUnit(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/AdminDiet/UpdateUnit/',body, {headers});
  // }
  // AddUnitToDiet(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/AdminDiet/AddUnitToDiet/',body, {headers});
  // }
  // EditDiet(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.get(this.api + '/api/AdminDiet/EditDiet/'+id, {headers});
  // }
  // DietProgram(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/AdminDiet/DietProgram/',body, {headers});
  // }
  // UpdateDiet(body){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.post(this.api + '/api/AdminDiet/UpdateDiet/',body, {headers});
  // }
  // DeleteUnitFromDeit(id){
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //     lang: this.cookieService.get('lang'),
  //     Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
  //   });
  //   return this.http.delete(this.api + '/api/AdminDiet/DeleteUnitFromDeit/'+id, {headers});
  // }
}
